(() => {
  const MQ = window.matchMedia("(max-width: 989px)");
  const KEY = "ps_recent_searches_v1";
  const MAX = 8;

  const norm = (v) => (v || "").toString().trim();
  const getItems = () => {
    try {
      const raw = JSON.parse(localStorage.getItem(KEY) || "[]");
      return Array.isArray(raw) ? raw.filter(Boolean) : [];
    } catch {
      return [];
    }
  };
  const setItems = (arr) => localStorage.setItem(KEY, JSON.stringify(arr.slice(0, MAX)));

  const addItem = (term) => {
    term = norm(term);
    if (!term) return;
    const list = getItems();
    const next = [term, ...list.filter((x) => x.toLowerCase() !== term.toLowerCase())];
    setItems(next);
  };

  const removeItem = (term) => {
    term = norm(term);
    const list = getItems().filter((x) => x.toLowerCase() !== term.toLowerCase());
    setItems(list);
  };

  const clearAll = () => setItems([]);

  function renderRecents(container) {
    const ul = container?.querySelector("[data-recent-list]");
    if (!ul) return;

    const items = getItems();
    ul.innerHTML = "";

    items.forEach((t) => {
      const li = document.createElement("li");
      li.className = "msh-recent__item";

      const a = document.createElement("a");
      a.className = "msh-recent__term";
      a.href = `/search?q=${encodeURIComponent(t)}`;
      a.textContent = t;

      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "msh-recent__remove";
      btn.setAttribute("aria-label", `Remove ${t}`);
      btn.textContent = "×";
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        removeItem(t);
        renderRecents(container);
      });

      li.appendChild(a);
      li.appendChild(btn);
      ul.appendChild(li);
    });

    const clearBtn = container.querySelector("[data-recent-clear]");
    if (clearBtn) {
      clearBtn.hidden = items.length === 0;
      clearBtn.onclick = () => {
        clearAll();
        renderRecents(container);
      };
    }
  }

  // ✅ 기존: 모바일 검색 모달 제어
  function initOne(modalRoot) {
    const home = modalRoot.querySelector(".mobile-search-home, [data-mobile-search-home]");
    const psWrap = modalRoot.querySelector(".predictive-search[data-predictive-search]");
    const input = modalRoot.querySelector('input[type="search"][name="q"]');
    const form = modalRoot.querySelector('form[role="search"]');
    const details = modalRoot.querySelector("details");

    const closeBtn = modalRoot.querySelector(".search-modal__close-button");
    if (closeBtn) {
      closeBtn.addEventListener("click", (e) => {
        if (!MQ.matches) return;
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();

        const vv = window.visualViewport;
        const setVV = () => {
          if (!vv || !MQ.matches) return;
          modalRoot.style.setProperty("--vvh", `${vv.height}px`);
          const coveredBottom = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
          modalRoot.style.setProperty("--vvb", `${coveredBottom}px`);
        };

        if (vv) {
          setVV();
          vv.addEventListener("resize", setVV);
          vv.addEventListener("scroll", setVV);
        }

        if (input) {
          input.value = "";
          input.dispatchEvent(new Event("input", { bubbles: true }));
          input.dispatchEvent(new Event("change", { bubbles: true }));
        }

        if (typeof modalRoot.close === "function") {
          modalRoot.close();
        } else if (details) {
          details.removeAttribute("open");
          details.open = false;
        }

        window.scrollTo({ top: 0, behavior: "smooth" });
      }, true);
    }

    if (!input) return;

    const update = () => {
      if (!MQ.matches) {
        if (home) home.hidden = true;
        if (psWrap) psWrap.classList.remove("is-hidden");
        return;
      }

      const hasValue = norm(input.value).length > 0;
      if (home) {
        home.hidden = hasValue;
        home.setAttribute("aria-hidden", String(hasValue));
      }
      if (psWrap) {
        psWrap.classList.toggle("is-hidden", !hasValue);
        psWrap.setAttribute("aria-hidden", String(!hasValue));
      }

      if (!hasValue && home) renderRecents(home);
    };

    input.addEventListener("input", update);
    input.addEventListener("focus", update);

    if (form) {
      form.addEventListener("submit", () => addItem(input.value));
    }

    if (details) {
      details.addEventListener("toggle", () => {
        if (details.open) {
          const vv = window.visualViewport;
          if (vv && MQ.matches) {
             modalRoot.style.setProperty("--vvh", `${vv.height}px`);
             modalRoot.style.setProperty("--vvb", `${Math.max(0, window.innerHeight - vv.height - vv.offsetTop)}px`);
          }
          update();
        }
      });
    }

    modalRoot.addEventListener("click", (e) => {
      const a = e.target.closest("a");
      if (!a) return;
      if (a.closest(".mobile-search-home") || a.closest(".predictive-search[data-predictive-search]")) {
        try {
          const u = new URL(a.href, window.location.origin);
          const q = u.searchParams.get("q");
          addItem(q || input.value);
        } catch {
          addItem(input.value);
        }
      }
    });

    update();
    MQ.addEventListener?.("change", update);
    window.addEventListener("resize", update);
  }

  // ✅ 신규: 데스크탑 검색창(Pill) 제어 로직 추가
  function initDesktopPill() {
    const pillForms = document.querySelectorAll('.header-search-pill');
    
    pillForms.forEach(form => {
      const input = form.querySelector('input[type="search"]');
      const staticDD = form.querySelector('.search-pill-dd--static');
      const resetBtn = form.querySelector('button[type="reset"]');

      if (!input) return;

      const updateState = () => {
        const val = (input.value || "").trim();
        const hasValue = val.length > 0;
        
        if (hasValue) {
          form.classList.add('has-query');
          if (resetBtn) resetBtn.classList.remove('hidden');
        } else {
          form.classList.remove('has-query');
          if (resetBtn) resetBtn.classList.add('hidden');
        }
        
        // 검색어가 없을 때 최신 검색어 업데이트
        if (!hasValue && staticDD) renderRecents(staticDD);
      };

      input.addEventListener('input', updateState);
      
      // 포커스 시 is-open 클래스 추가하여 드롭다운 열기
      input.addEventListener('focus', () => {
        form.classList.add('is-open');
        updateState();
      });

      // 바깥 영역 클릭 시 드롭다운 닫기
      document.addEventListener('click', (e) => {
        if (!form.contains(e.target)) {
          form.classList.remove('is-open');
        }
      });

      // X(리셋) 버튼 기능
      if (resetBtn) {
        resetBtn.addEventListener('click', (e) => {
          e.preventDefault();
          input.value = '';
          updateState();
          input.focus();
        });
      }

      form.addEventListener("submit", () => addItem(input.value));

      form.addEventListener("click", (e) => {
        const a = e.target.closest("a");
        if (!a) return;
        try {
          const u = new URL(a.href, window.location.origin);
          const q = u.searchParams.get("q");
          addItem(q || input.value);
        } catch {
          addItem(input.value);
        }
      });
    });
  }

  function boot() {
    // 1. 모바일 검색 모달 실행
    document.querySelectorAll("details-modal.header__search").forEach(initOne);
    // 2. 데스크탑 검색바 실행 (새로 추가됨!)
    initDesktopPill();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();